import { render, staticRenderFns } from "./ShipmentCreate.vue?vue&type=template&id=18bd4768&scoped=true"
import script from "./ShipmentCreate.vue?vue&type=script&lang=js"
export * from "./ShipmentCreate.vue?vue&type=script&lang=js"
import style0 from "./ShipmentCreate.vue?vue&type=style&index=0&id=18bd4768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd4768",
  null
  
)

export default component.exports